import React, { useEffect, useRef, useState } from "react";
import styles from "./PrivateMsg.module.css";
import {
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { HiOutlineChatBubbleLeft } from "react-icons/hi2";
import image1 from "../../../../assets/vendorimg6.png";
import image2 from "../../../../assets/avatar-2.png";
import Person from "../../../../assets/dummy.png";
import { List, Row, Skeleton } from "antd";
import { GoDotFill } from "react-icons/go";
import { ImAttachment } from "react-icons/im";
import { IoCall, IoClose, IoVideocam } from "react-icons/io5";
import messageImg from "../../../../assets/staticImages/gallery/g7.png";
import messageImg2 from "../../../../assets/staticImages/chatImg2.png";
import { useNavigate } from "react-router-dom";
import Modal from "../../../../components/modal/Modal";
import { FaRegUserCircle, FaUserPlus } from "react-icons/fa";
import { dummyMembers } from "../ChatRoom/ChatRoom";
import { BsFillChatLeftTextFill } from "react-icons/bs";
import PhoneNumberModal from "../../../../components/phoneNumberModal/PhoneNumberModal";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";
import { useDispatch, useSelector } from "react-redux";
import { ChatMiddleware } from "../../../../Store/Middlewares/ChatMiddleware";
import Pusher from "pusher-js";
import {
  getChatList,
  getMessages,
  updateMessages,
} from "../../../../Store/Actions/ChatActions";
import InfiniteScroll from "react-infinite-scroll-component";
import { VideoCallMiddleware } from "../../../../Store/Middlewares/VideoCallMiddleware";

const PrivateMsg = ({ chatData, screen, activeKey }) => {
  const dispatch = useDispatch();
  const ChatList = useSelector((state) => state.ChatReducer.chatList);
  const Messages = useSelector((state) => state.ChatReducer.chatMessages);
  const chatObject = useSelector((state) => state.ChatReducer.chatObject);
  const guestList = useSelector((state) => state.ChatReducer.guestList);

  const [message, setmessage] = useState("");
  const [addMembers, setAddMembers] = useState(false);
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
  const navigate = useNavigate();
  const role = Storage.getERole("@role");
  const [search, setSearch] = useState("");
  const [selectedChat, setSelectedChat] = useState();
  console.log("selectedChat", selectedChat);
  const user = useSelector((state) => state.AuthReducer.user);
  const ref = useRef();
  const privateRef = useRef();
  const chatchannel = useRef(null);
  const chatListchannel = useRef(null);
  const messagesEndRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [sendingPending, setSendingPending] = useState(false);
  const [searchGuest, setSearchGuest] = useState("");

  const fileImage = React.useRef();

  const handleClickImage = (event) => {
    if (!sendingPending) {
      fileImage.current.click();
    }
  };
  console.log("selectedChat", selectedChat);

  useEffect(() => {
    dispatch(ChatMiddleware.getChatListData({ search: undefined })).then(
      (data) => {
        setSelectedChat(data?.[0]);
        initiateChatListPusher();
      }
    );

    navigateChatStart();

    return () => {
      if (chatListchannel?.current) {
        chatListchannel?.current?.unsubscribe();
      }
    };
  }, []);

  const initiateChatListPusher = () => {
    let pusher = new Pusher("ac81b678f2fe61e8c6eb", { cluster: "mt1" });
    chatListchannel.current = pusher.subscribe(user.id?.toString());
    chatListchannel.current.bind("App\\Events\\ChatLists", (data) => {
      console.log("getChatList", data);
      if (data.is_private_message == false) {
        dispatch(getChatList(data?.data));
        setSearch("");
      }
    });
  };

  const onSearchValue = (val) => {
    setSearch(val);
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      dispatch(ChatMiddleware.getChatListData({ search: val }));
    }, 1000);
  };

  useEffect(() => {
    if (selectedChat) {
      dispatch(
        ChatMiddleware.getChatMessagesData({
          id: selectedChat?.id,
          next_page_url: undefined,
        })
      );

      initiatePusher();
    }

    return () => {
      if (chatchannel?.current) {
        chatchannel?.current?.unsubscribe();
      }
    };
  }, [selectedChat?.id]);

  const initiatePusher = () => {
    let pusher = new Pusher("ac81b678f2fe61e8c6eb", { cluster: "mt1" });
    chatchannel.current = pusher.subscribe(selectedChat?.id.toString());
    chatchannel.current.bind("App\\Events\\SendMessage", (data) => {
      console.log(
        "SendMessage",
        data,
        selectedChat?.id == data.message.chat_list_id
      );
      if (selectedChat?.id == data.message.chat_list_id && activeKey == 1) {
        dispatch(updateMessages(data?.message));
      }
    });
  };

  const onPressSendMessage = () => {
    if (message !== "" && !sendingPending) {
      setSendingPending(true);
      setmessage("");
      dispatch(
        ChatMiddleware.sendMessage({
          id: selectedChat?.id,
          message: message,
          type: "text",
        })
      )
        .then(() => {
          setSendingPending(false);
          setmessage("");
        })
        .catch(() => {
          setSendingPending(false);
          setmessage("");
        });
    }
  };

  const sentAttachment = (img) => {
    let selectedType = img?.type == "application/pdf" ? "attachment" : "image";

    setSendingPending(true);
    dispatch(
      ChatMiddleware.sendMessage({
        id: selectedChat?.id,
        message: img,
        type: selectedType,
      })
    )
      .then(() => {
        setSendingPending(false);
      })
      .catch(() => {
        setSendingPending(false);
      });
  };

  const OnEndReached = () => {
    if (chatObject?.links?.next) {
      setLoading(true);
      dispatch(
        ChatMiddleware.getChatMessagesData({
          id: selectedChat?.id,
          next_page_url: chatObject?.links?.next,
        })
      )
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  const openGuestListModal = () => {
    if (role == roles.client) {
      dispatch(ChatMiddleware.GetGuestList({ search: undefined })).then(() => {
        setAddMembers(true);
      });
    } else if (role == roles.vendor) {
      dispatch(ChatMiddleware.GetClientsList()).then(() => {
        setAddMembers(true);
      });
    }
  };

  const onSearchGuest = (val) => {
    setSearchGuest(val);
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      dispatch(ChatMiddleware.GetGuestList({ search: val }));
    }, 1000);
  };
  const onChatStart = (val) => {
    dispatch(ChatMiddleware.createChatList({ id: val?.id })).then((data) => {
      setSelectedChat(data);
      setAddMembers(false);
    });
  };

  const navigateChatStart = () => {
    if (screen == "guestDetailScreen") {
      dispatch(ChatMiddleware.createChatList({ id: chatData?.id })).then(
        (data) => {
          setSelectedChat(data);
          setAddMembers(false);
        }
      );
    }
    if (screen == "eventOverviewScreen") {
      dispatch(ChatMiddleware.createChatList({ id: chatData?.client_id })).then(
        (data) => {
          setSelectedChat(data);
          setAddMembers(false);
        }
      );
    }
    if (screen == "vendorDetailScreen") {
      dispatch(ChatMiddleware.createChatList({ id: chatData?.id })).then(
        (data) => {
          setSelectedChat(data);
          setAddMembers(false);
        }
      );
    }
  };

  const onPressVideoCall = () => {
    dispatch(
      VideoCallMiddleware.generateSingleCallToken({
        id: selectedChat?.receiver_id,
      })
    )
      .then((data) => {
        navigate("/singleVideoCall", {
          // navigate("/videoCall", {
          state: {
            data,
            group: false,
            incomming: false,
          },
        });
      })
      .catch();
  };

  const renderInbox = (item, index) => {
    return (
      <div
        onClick={() => {
          let newItem = ChatList?.map((data) =>
            data.id == item.id ? { ...data, last_message_read: true } : data
          );
          dispatch(getChatList(newItem));
          setSelectedChat(item);
        }}
        className={
          !item?.last_message_read ? styles.listItem : styles.unSeenlistItem
        }
      >
        <div className={styles.listLeft}>
          <img src={item?.profile_picture ? item?.profile_picture : Person} />
          <div className={styles.inboxContent}>
            <TextComponent text={item?.name} textClass={styles.name} />
            {item?.last_message_type == "text" ? (
              // <div className={styles.from_message}>
              <TextComponent
                text={item?.last_message}
                textClass={
                  !item?.last_message_read
                    ? styles.lastMsg
                    : styles.unSeenLastMsg
                }
              />
            ) : // </div>
            item?.last_message_type == "image" ? (
              <div className={styles.inboxMessageImg}>
                <img src={item?.last_message} />
              </div>
            ) : item?.last_message_type == "attachment" ? (
              <div className={styles.attachmentDiv}>
                <div>
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 39"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_994_11129)">
                      <path
                        d="M23.8477 8.66983V1.32422C23.9581 1.41627 24.0686 1.52673 24.1606 1.61878L34.5807 12.0389C34.6728 12.1309 34.7832 12.2414 34.8753 12.3518H27.5297C26.554 12.3489 25.6192 11.9601 24.9293 11.2702C24.2394 10.5803 23.8506 9.64547 23.8477 8.66983Z"
                        fill="#ED73AA"
                      />
                      <path
                        d="M36.6253 16.0339H27.5307C25.5777 16.0339 23.7046 15.258 22.3236 13.877C20.9426 12.496 20.1667 10.6229 20.1667 8.66987V-0.424696C19.7658 -0.497955 19.3592 -0.534925 18.9516 -0.535156H9.12067C7.65588 -0.535156 6.25108 0.0467315 5.21531 1.0825C4.17954 2.11827 3.59766 3.52307 3.59766 4.98786V34.444C3.59766 35.9088 4.17954 37.3136 5.21531 38.3493C6.25108 39.3851 7.65588 39.967 9.12067 39.967H31.2127C32.6775 39.967 34.0823 39.3851 35.1181 38.3493C36.1539 37.3136 36.7358 35.9088 36.7358 34.444V17.249C36.7355 16.8414 36.6986 16.4348 36.6253 16.0339ZM10.9617 23.3979H18.3257C18.814 23.3979 19.2822 23.5919 19.6275 23.9371C19.9727 24.2824 20.1667 24.7507 20.1667 25.2389C20.1667 25.7272 19.9727 26.1955 19.6275 26.5407C19.2822 26.886 18.814 27.0799 18.3257 27.0799H10.9617C10.4734 27.0799 10.0051 26.886 9.65989 26.5407C9.31464 26.1955 9.12067 25.7272 9.12067 25.2389C9.12067 24.7507 9.31464 24.2824 9.65989 23.9371C10.0051 23.5919 10.4734 23.3979 10.9617 23.3979ZM29.3717 34.444H10.9617C10.4734 34.444 10.0051 34.25 9.65989 33.9047C9.31464 33.5595 9.12067 33.0912 9.12067 32.603C9.12067 32.1147 9.31464 31.6464 9.65989 31.3012C10.0051 30.9559 10.4734 30.7619 10.9617 30.7619H29.3717C29.86 30.7619 30.3283 30.9559 30.6735 31.3012C31.0188 31.6464 31.2127 32.1147 31.2127 32.603C31.2127 33.0912 31.0188 33.5595 30.6735 33.9047C30.3283 34.25 29.86 34.444 29.3717 34.444Z"
                        fill="#ED73AA"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_994_11129">
                        <rect
                          width="38.6611"
                          height="38.6611"
                          fill="white"
                          transform="translate(0.375 0.00585938)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <TextComponent
                  textClass={styles.attachmentText}
                  text={item?.last_message.replace(/^.*[\\/]/, "")}
                />
              </div>
            ) : null}
            {/* <TextComponent
              text={item?.last_message}
              textClass={item?.last_message_read ? styles.lastMsg : styles.unSeenLastMsg}
            /> */}
          </div>
        </div>
        {!item?.last_message_read ? (
          <div className={styles.listRight}>
            <GoDotFill className={styles.dot} />
          </div>
        ) : null}
      </div>
    );
  };
  const renderMessages = (item, index) => {
    if (item?.sender_id == user?.id) {
      return (
        <div className={styles.flexEnd} key={item.id}>
          <div className={styles.to_listItem}>
            <div className={styles.flexEnd}>
              <img
                src={user?.image ? user?.image : Person}
                className={styles.proflileImg}
              />
            </div>
            {item?.type == "text" ? (
              <div className={styles.to_message}>
                <TextComponent text={item?.message} />
              </div>
            ) : item?.type == "image" ? (
              <div
                style={{ cursor: "pointer" }}
                className={styles.to_messageImg}
                onClick={() => openInNewTab(item?.message)}
              >
                <img src={item?.message} />
              </div>
            ) : item?.type == "attachment" ? (
              <div
                style={{ cursor: "pointer" }}
                className={styles.attachmentDiv}
                onClick={() => openInNewTab(item?.message)}
              >
                <div className={styles.to_messageImg}>
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 40 39"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_994_11129)">
                      <path
                        d="M23.8477 8.66983V1.32422C23.9581 1.41627 24.0686 1.52673 24.1606 1.61878L34.5807 12.0389C34.6728 12.1309 34.7832 12.2414 34.8753 12.3518H27.5297C26.554 12.3489 25.6192 11.9601 24.9293 11.2702C24.2394 10.5803 23.8506 9.64547 23.8477 8.66983Z"
                        fill="#ED73AA"
                      />
                      <path
                        d="M36.6253 16.0339H27.5307C25.5777 16.0339 23.7046 15.258 22.3236 13.877C20.9426 12.496 20.1667 10.6229 20.1667 8.66987V-0.424696C19.7658 -0.497955 19.3592 -0.534925 18.9516 -0.535156H9.12067C7.65588 -0.535156 6.25108 0.0467315 5.21531 1.0825C4.17954 2.11827 3.59766 3.52307 3.59766 4.98786V34.444C3.59766 35.9088 4.17954 37.3136 5.21531 38.3493C6.25108 39.3851 7.65588 39.967 9.12067 39.967H31.2127C32.6775 39.967 34.0823 39.3851 35.1181 38.3493C36.1539 37.3136 36.7358 35.9088 36.7358 34.444V17.249C36.7355 16.8414 36.6986 16.4348 36.6253 16.0339ZM10.9617 23.3979H18.3257C18.814 23.3979 19.2822 23.5919 19.6275 23.9371C19.9727 24.2824 20.1667 24.7507 20.1667 25.2389C20.1667 25.7272 19.9727 26.1955 19.6275 26.5407C19.2822 26.886 18.814 27.0799 18.3257 27.0799H10.9617C10.4734 27.0799 10.0051 26.886 9.65989 26.5407C9.31464 26.1955 9.12067 25.7272 9.12067 25.2389C9.12067 24.7507 9.31464 24.2824 9.65989 23.9371C10.0051 23.5919 10.4734 23.3979 10.9617 23.3979ZM29.3717 34.444H10.9617C10.4734 34.444 10.0051 34.25 9.65989 33.9047C9.31464 33.5595 9.12067 33.0912 9.12067 32.603C9.12067 32.1147 9.31464 31.6464 9.65989 31.3012C10.0051 30.9559 10.4734 30.7619 10.9617 30.7619H29.3717C29.86 30.7619 30.3283 30.9559 30.6735 31.3012C31.0188 31.6464 31.2127 32.1147 31.2127 32.603C31.2127 33.0912 31.0188 33.5595 30.6735 33.9047C30.3283 34.25 29.86 34.444 29.3717 34.444Z"
                        fill="#ED73AA"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_994_11129">
                        <rect
                          width="38.6611"
                          height="38.6611"
                          fill="white"
                          transform="translate(0.375 0.00585938)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className={styles.to_messageImg}>
                  <TextComponent
                    textClass={styles.attachmentText}
                    text={item?.message.replace(/^.*[\\/]/, "")}
                  />
                </div>
              </div>
            ) : null}
            <TextComponent
              text={item?.formatted_time}
              textClass={styles.to_date}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.from_listItem} key={item.id}>
          <img
            src={item?.sender_image ? item?.sender_image : Person}
            className={styles.proflileImg}
          />
          {item?.type == "text" ? (
            <div className={styles.from_message}>
              <TextComponent text={item?.message} textClass={styles.message} />
            </div>
          ) : item?.type == "image" ? (
            <div
              style={{ cursor: "pointer" }}
              className={styles.messageImg}
              onClick={() => openInNewTab(item?.message)}
            >
              <img src={item?.message} />
            </div>
          ) : item?.type == "attachment" ? (
            <div
              style={{ cursor: "pointer" }}
              className={styles.attachmentDiv}
              onClick={() => openInNewTab(item?.message)}
            >
              <div className={styles.messageImg}>
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 40 39"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_994_11129)">
                    <path
                      d="M23.8477 8.66983V1.32422C23.9581 1.41627 24.0686 1.52673 24.1606 1.61878L34.5807 12.0389C34.6728 12.1309 34.7832 12.2414 34.8753 12.3518H27.5297C26.554 12.3489 25.6192 11.9601 24.9293 11.2702C24.2394 10.5803 23.8506 9.64547 23.8477 8.66983Z"
                      fill="#ED73AA"
                    />
                    <path
                      d="M36.6253 16.0339H27.5307C25.5777 16.0339 23.7046 15.258 22.3236 13.877C20.9426 12.496 20.1667 10.6229 20.1667 8.66987V-0.424696C19.7658 -0.497955 19.3592 -0.534925 18.9516 -0.535156H9.12067C7.65588 -0.535156 6.25108 0.0467315 5.21531 1.0825C4.17954 2.11827 3.59766 3.52307 3.59766 4.98786V34.444C3.59766 35.9088 4.17954 37.3136 5.21531 38.3493C6.25108 39.3851 7.65588 39.967 9.12067 39.967H31.2127C32.6775 39.967 34.0823 39.3851 35.1181 38.3493C36.1539 37.3136 36.7358 35.9088 36.7358 34.444V17.249C36.7355 16.8414 36.6986 16.4348 36.6253 16.0339ZM10.9617 23.3979H18.3257C18.814 23.3979 19.2822 23.5919 19.6275 23.9371C19.9727 24.2824 20.1667 24.7507 20.1667 25.2389C20.1667 25.7272 19.9727 26.1955 19.6275 26.5407C19.2822 26.886 18.814 27.0799 18.3257 27.0799H10.9617C10.4734 27.0799 10.0051 26.886 9.65989 26.5407C9.31464 26.1955 9.12067 25.7272 9.12067 25.2389C9.12067 24.7507 9.31464 24.2824 9.65989 23.9371C10.0051 23.5919 10.4734 23.3979 10.9617 23.3979ZM29.3717 34.444H10.9617C10.4734 34.444 10.0051 34.25 9.65989 33.9047C9.31464 33.5595 9.12067 33.0912 9.12067 32.603C9.12067 32.1147 9.31464 31.6464 9.65989 31.3012C10.0051 30.9559 10.4734 30.7619 10.9617 30.7619H29.3717C29.86 30.7619 30.3283 30.9559 30.6735 31.3012C31.0188 31.6464 31.2127 32.1147 31.2127 32.603C31.2127 33.0912 31.0188 33.5595 30.6735 33.9047C30.3283 34.25 29.86 34.444 29.3717 34.444Z"
                      fill="#ED73AA"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_994_11129">
                      <rect
                        width="38.6611"
                        height="38.6611"
                        fill="white"
                        transform="translate(0.375 0.00585938)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <TextComponent
                textClass={styles.attachmentText}
                text={item?.message.replace(/^.*[\\/]/, "")}
              />
            </div>
          ) : null}
          <TextComponent text={item?.formatted_time} textClass={styles.date} />
        </div>
      );
    }
  };
  return (
    <div ref={privateRef} className={styles.mainCon}>
      <div className={styles.headerCon}>
        <div className={styles.headerLeft}>
          <div className={styles.search}>
            <SearchInput
              value={search}
              onChange={(e) => onSearchValue(e.target.value)}
              placeholder={"Search"}
            />
          </div>
          {/* {role != roles.staff && ( */}
          <div className={styles.chat} onClick={() => openGuestListModal()}>
            {/* <HiOutlineChatBubbleLeft className={styles.chatIcon} /> */}
            <FaRegUserCircle className={styles.chatIcon} />
          </div>
          {/* )} */}
        </div>
        <div className={styles.headerRight}>
          <div className={styles.nameDiv}>
            <TextComponent
              text={selectedChat ? selectedChat?.name : "Chat"}
              textClass={styles.headerName}
            />
          </div>
          {selectedChat && (
            <div className={styles.callDiv}>
              <div
                className={styles.callIcon}
                onClick={() => setIsPhoneModalOpen(true)}
              >
                <IoCall className={styles.chatIcon} />
              </div>
              <div
                className={styles.callIcon}
                onClick={() => onPressVideoCall()}
              >
                <IoVideocam className={styles.chatIcon} />
              </div>
              {/* {role != roles.vendor && (
              <div
                className={styles.callIcon}
                onClick={() => onPressVideoCall()}
              >
                <IoVideocam className={styles.chatIcon} />
              </div>
            )} */}
            </div>
          )}
        </div>
      </div>
      <div className={styles.mainConContent}>
        <div className={styles.mainConLeft}>
          <List
            className={styles.list}
            // grid={{ gutter:16}}
            // itemLayout="horizontal"
            dataSource={ChatList ? ChatList : []}
            renderItem={renderInbox}
          />
        </div>
        {selectedChat ? (
          <div className={styles.mainConRight}>
            <div
              id="scrollableDiv"
              className={styles.messageList}
              style={{
                // height: 580,
                overflow: "auto",
                display: "flex",
                flexDirection: "column-reverse",
                padding: 10,
              }}
            >
              <InfiniteScroll
                dataLength={Messages}
                next={OnEndReached}
                inverse={true}
                hasMore={true}
                scrollableTarget="scrollableDiv"
                style={{ display: "flex", flexDirection: "column-reverse" }}
              >
                <div ref={messagesEndRef} />
                {Messages.map((item) => {
                  return renderMessages(item);
                })}
                {loading && (
                  <Skeleton
                    avatar
                    paragraph={{
                      rows: 1,
                    }}
                    active
                  />
                )}
              </InfiniteScroll>
            </div>
            <div className={styles.inputDiv}>
              <div className={styles.chatInputDiv}>
                <input
                  value={message}
                  onChange={(e) => setmessage(e.target.value)}
                  className={styles.chatInput}
                  placeholder={"Type your message here"}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") onPressSendMessage();
                  }}
                />
                <div
                  className={styles.pinIconDiv}
                  style={{
                    cursor: sendingPending ? "not-allowed" : "pointer",
                    opacity: sendingPending ? 0.2 : 1,
                  }}
                >
                  <ImAttachment
                    onClick={() => {
                      handleClickImage();
                    }}
                    className={styles.pinIcon}
                  />
                  <input
                    type="file"
                    ref={fileImage}
                    accept={"application/pdf,image/*"}
                    onChange={(e) => {
                      sentAttachment(e.target.files[0]);
                    }}
                    style={{ display: "none" }}
                  />
                </div>
              </div>
              <div
                onClick={() => onPressSendMessage()}
                className={styles.sendIconDiv}
                style={{
                  cursor:
                    message == "" || sendingPending ? "not-allowed" : "pointer",
                  opacity: message == "" || sendingPending ? 0.2 : 1,
                }}
              >
                <svg
                  className={styles.sendIcon}
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.4904 0.159439L0.616388 13.3558C-0.27686 13.8691 -0.163353 15.1127 0.724959 15.4878L5.97094 17.6888L20.1494 5.19321C20.4208 4.95139 20.8058 5.32152 20.5738 5.60282L8.68523 20.0873V24.06C8.68523 25.2247 10.0917 25.6836 10.7826 24.8397L13.9164 21.0249L20.0655 23.601C20.7663 23.8971 21.5658 23.4579 21.6941 22.7028L25.2473 1.38334C25.4151 0.386452 24.3442 -0.334068 23.4904 0.159439V0.159439Z"
                    fill="var(--primary-color)"
                  />
                </svg>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <Modal
        isModalOpen={addMembers}
        setIsModalOpen={setAddMembers}
        closable={true}
        className={styles.modal}
        pinkBg
      >
        <div className={styles.modalCon}>
          <TextComponent
            text={role == roles.vendor ? "Clients" : "Guest List"}
            textClass={styles.modalHeading}
          />
          <div className={styles.modalSearchCon}>
            <SearchInput
              value={searchGuest}
              onChange={(e) => onSearchGuest(e.target.value)}
              placeholder={"Search"}
            />
            {/* <div className={styles.addUserDiv}>
              <FaUserPlus />
            </div> */}
          </div>
          <List
            dataSource={guestList}
            className={styles.modalList}
            // grid={{}}
            // itemLayout="horizontal"
            renderItem={(item, index) => (
              <Row key={index} className={styles.modalItem}>
                <div className={styles.modalMembersDetails}>
                  <img src={item?.image ? item?.image : Person} />
                  <TextComponent
                    text={item?.name}
                    textClass={styles.modalMembersName}
                  />
                </div>
                <div
                  onClick={() => onChatStart(item)}
                  style={{ cursor: "pointer" }}
                  className={styles.crossIconDiv}
                >
                  <BsFillChatLeftTextFill />
                </div>
              </Row>
            )}
          />
        </div>
      </Modal>
      <PhoneNumberModal
        isPhoneModalOpen={isPhoneModalOpen}
        setIsPhoneModalOpen={setIsPhoneModalOpen}
        phoneNumber={selectedChat?.contact_no}
      />
    </div>
  );
};

export default PrivateMsg;
